import * as React from 'react';
import { ApolloProvider } from '@apollo/react-hooks';

import { useGraphQLClient } from '../../../graphql-client';
import Account from '../../../Account';
import Analytics from '../../../Engine/components/Analytics';
import IsDemo from '../../../Engine/components/IsDemo';
import AccountStoreProvider from '../provider/AccountStoreProvider';
import { GuardedApolloProvider } from '../../../GuardedApolloProvider';
import { BootstrapGate } from '@shared/ui';
import PixelPageViewWatcher from '../../../Engine/components/PixelPageViewWatcher';
import { ErrorManager } from '@entities/error';

export const Module = () => {
	const client = useGraphQLClient();

	return (
		<BootstrapGate>
			<ApolloProvider client={client}>
				<AccountStoreProvider>
					<Analytics />
					<IsDemo />
					<PixelPageViewWatcher />
					<GuardedApolloProvider client={client}>
						<Account />
					</GuardedApolloProvider>

					<ErrorManager />
				</AccountStoreProvider>
			</ApolloProvider>
		</BootstrapGate>
	);
};

export default Module;
